const compare = (fa, fb) => {
  let a = fa?.label.toString().toLowerCase()
  let b = fb?.label.toString().toLowerCase()
  if (a < b) {
    return -1
  } else if (a > b) {
    return 1
  } else return 0
}
export default compare
